import React, { useState } from "react";
import Dashboard from "../../Dasboard/Dashboard";
import Rout from "../../../assets/fiber.webp";
import { Grid } from "@material-ui/core";
import Cardash from "../../Dasboard/Cardash/Cardash";
import { EyeOff, EyeEmpty, Copy, Group, InfoEmpty } from "iconoir-react";

const AdminComp = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isActive1, setIsActive1] = useState(false);

  const togglePasswordVisiblity = () => setPasswordShown(prev => !prev);
  const togglePasswordVisiblity1 = () => setPasswordShown1(prev => !prev);

  return (
    <Dashboard
      MInicio=""
      Msolicitudes=""
      Mempaquetar=""
      Mservicios="active"
      Mcompra=""
      Mcunyompra=""
      Mcpotenciales=""
      Madminportal=""
      Mcampaña=""
    >
      <div className="p-4 md:p-6">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className="bg-[#e4d2d2] rounded-xl shadow-md p-4 md:p-6 flex flex-col md:flex-row gap-4 md:gap-6 items-center">
              <img 
                src={Rout} 
                className="w-1/2 md:w-1/5 aspect-square object-contain"
                alt="Router"
              />

              <div className="w-full space-y-4">
                <div className="flex items-center gap-2 text-gray-700">
                  <InfoEmpty className="w-5 h-5" />
                  <h3 className="text-lg font-semibold">Información del servicio (WIFI A 2.4 GHz)</h3>
                </div>

                <div className="space-y-4">
                  <div className="flex flex-col md:flex-row gap-3 items-center">
                    <label className="w-24 md:w-32 text-sm font-medium">Nombre:</label>
                    <div className="flex-1 flex gap-2">
                      <div className="relative flex-1">
                        <input
                          type="text"
                          placeholder="NN"
                          className="w-full border rounded-lg px-4 py-2 pr-12 focus:outline-none focus:ring-2 focus:ring-red-300"
                        />
                      </div>
                      <button className="px-4 py-2 btn btn-outline-danger"
                              type="button">
                        Cambiar
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-3 items-center">
                    <label className="w-24 md:w-32 text-sm font-medium">Contraseña:</label>
                    <div className="flex-1 flex gap-2">
                      <div className="relative flex-1">
                        <input
                          type={passwordShown ? "text" : "password"}
                          placeholder="********"
                          className="w-full border rounded-lg px-4 py-2 pr-12 focus:outline-none focus:ring-2 focus:ring-red-300"
                        />
                        <button
                          onClick={togglePasswordVisiblity}
                          className="absolute right-2 top-2 p-1 hover:bg-gray-100 rounded-full"
                        >
                          {passwordShown ? 
                            <EyeOff className="w-5 h-5 text-gray-500" /> : 
                            <EyeEmpty className="w-5 h-5 text-gray-500" />}
                        </button>
                      </div>
                      <button className="px-4 py-2 btn btn-outline-danger"
                              type="button">
                        Cambiar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Cardash Component */}
            <Cardash
              height="auto"
              titulo={
                <div className="flex items-center gap-2 mb-4">
                  <InfoEmpty className="w-5 h-5" />
                  <h3 className="text-lg font-semibold">Información del servicio (WIFI A 2.4 GHz)</h3>
                </div>
              }
              texto={
                <div className="space-y-4">
                  <div className="flex flex-col md:flex-row gap-3 items-center">
                    <label className="w-24 md:w-32 text-sm font-medium">Nombre:</label>
                    <div className="flex-1 flex gap-2">
                      <input
                        type="text"
                        placeholder="NN"
                        className="flex-1 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                      />
                      <button className="px-4 py-2 btn btn-outline-danger"
                              type="button">
                        Cambiar
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-3 items-center">
                    <label className="w-24 md:w-32 text-sm font-medium">Contraseña:</label>
                    <div className="flex-1 flex gap-2">
                      <div className="relative flex-1">
                        <input
                          type={passwordShown1 ? "text" : "password"}
                          placeholder="********"
                          className="w-full border rounded-lg px-4 py-2 pr-12 focus:outline-none focus:ring-2 focus:ring-red-300"
                        />
                        <button
                          onClick={togglePasswordVisiblity1}
                          className="absolute right-2 top-2 p-1 hover:bg-gray-100 rounded-full"
                        >
                          {passwordShown1 ? 
                            <EyeOff className="w-5 h-5 text-gray-500" /> : 
                            <EyeEmpty className="w-5 h-5 text-gray-500" />}
                        </button>
                      </div>
                      <button className="px-4 py-2 btn btn-outline-danger"
                              type="button">
                        Cambiar
                      </button>
                    </div>
                  </div>
                </div>
              }
              color="white"
              habilitado="none"
            />
          </Grid>
        </Grid>
      </div>
    </Dashboard>
  );
};

export default AdminComp;